// Comprehensive Algerian vocabulary data for import
import { vocabularyAPI } from './api';

export const algerianVocabulary = [
  // GREETINGS - Your authentic vocabulary
  {
    algerianWord: "a'salam 3alaykoum",
    englishTranslation: "Hello (peace be upon you)",
    pronunciation: "a-sel-em a'al-ay-kum",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "salam",
    englishTranslation: "Hello (peace be upon you)",
    pronunciation: "se-lem",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "3'slama",
    englishTranslation: "Hello (peace be upon you)",
    pronunciation: "a'as-le-ma",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "salut",
    englishTranslation: "Hello",
    pronunciation: "sa-loo",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "wsh",
    englishTranslation: "Hello (informal)",
    pronunciation: "wesh",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "sa7a",
    englishTranslation: "Hello (informal)",
    pronunciation: "sa-Ha",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "b'slama",
    englishTranslation: "Goodbye (peace be upon you)",
    pronunciation: "b-sle-ma",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "bye bye",
    englishTranslation: "Goodbye",
    pronunciation: "biy biy",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "[aya] omb3ad [inshallah]",
    englishTranslation: "See you later",
    pronunciation: "aya um-ba'ad in-sha-la",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "[aya] sa7a",
    englishTranslation: "See ya",
    pronunciation: "aya sa-Ha",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "sba7 lkhir",
    englishTranslation: "Good morning",
    pronunciation: "sbaH el-kheer",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "sba7 e'nour",
    englishTranslation: "response to 'good morning'",
    pronunciation: "sbaH e-noor",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "tesba7 bkhir (to m.)",
    englishTranslation: "Goodnight",
    pronunciation: "tes-baħ b-kheer",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "tesab7i bkhir (to f.)",
    englishTranslation: "Goodnight",
    pronunciation: "tes-ab-Hi b-kheer",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "bonne nuit",
    englishTranslation: "Goodnight",
    pronunciation: "bon nwee",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },
  {
    algerianWord: "layla sa3ida",
    englishTranslation: "Goodnight",
    pronunciation: "lay-la sa-a'aee-da",
    exampleSentence: "",
    category: "greetings",
    difficulty: "beginner"
  },

  // INTRODUCING YOURSELF
  {
    algerianWord: "wusmek?",
    englishTranslation: "what's your name?",
    pronunciation: "wus-mek",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "wusemni",
    englishTranslation: "my name is",
    pronunciation: "wus-em-ni",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "ismi",
    englishTranslation: "my name is",
    pronunciation: "is-mee",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "ana",
    englishTranslation: "my name is",
    pronunciation: "ena",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "ch7al f 3mrek?",
    englishTranslation: "how old are you?",
    pronunciation: "sh-Hal fi a'am-rek",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "f 3mri",
    englishTranslation: "I am ... years old",
    pronunciation: "fee a'am-ri",
    exampleSentence: "f 3mri 3shrin sna",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "3ndi",
    englishTranslation: "I am ... years old",
    pronunciation: "a'an-di",
    exampleSentence: "3ndi 3shrin sna",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "min win nta (to male)",
    englishTranslation: "where are you from?",
    pronunciation: "min ween en-ta",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "min win nti (to female)",
    englishTranslation: "where are you from?",
    pronunciation: "min ween en-ti",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "ana min",
    englishTranslation: "I am from",
    pronunciation: "ena min",
    exampleSentence: "ana min lengliz = I am from England",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "baba / mama min",
    englishTranslation: "my father / mother is from",
    pronunciation: "be-ba / mama min",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "win tskoun (m.)",
    englishTranslation: "where do you live?",
    pronunciation: "ween tes-kun",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "win tsoukni (f.)",
    englishTranslation: "where do you live?",
    pronunciation: "ween tes-uk-ni",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "win t3ish (m.)",
    englishTranslation: "where do you live?",
    pronunciation: "ween ta'a-eesh",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "win t3ishi (f.)",
    englishTranslation: "where do you live?",
    pronunciation: "ween ta'a-eesh-i",
    exampleSentence: "",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "nskoun f",
    englishTranslation: "I live in",
    pronunciation: "nes-kun fi",
    exampleSentence: "nskoun f London",
    category: "introducing",
    difficulty: "beginner"
  },
  {
    algerianWord: "n3ish f",
    englishTranslation: "I live in",
    pronunciation: "na'a-eesh fi",
    exampleSentence: "n3ish f London",
    category: "introducing",
    difficulty: "beginner"
  },

  // COUNTRIES & ETHNICITIES
  {
    algerianWord: "dzair",
    englishTranslation: "Algeria",
    pronunciation: "d-zay-er",
    exampleSentence: "ana min dzair",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "dziri (m)",
    englishTranslation: "Algeria(n)",
    pronunciation: "d-zir-i",
    exampleSentence: "ana dziri",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "dziria (f)",
    englishTranslation: "Algeria(n)",
    pronunciation: "d-zir-i-ya",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "lengliz",
    englishTranslation: "England",
    pronunciation: "len-gleez",
    exampleSentence: "ana min lengliz",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "inglizi (m.)",
    englishTranslation: "English",
    pronunciation: "in-gli-zee",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "inglizia (f.)",
    englishTranslation: "English",
    pronunciation: "in-gli-zee-ya",
    exampleSentence: "ana iglizia",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "fransa",
    englishTranslation: "France",
    pronunciation: "fran-sa",
    exampleSentence: "ana min fransa",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "fransi (m.)",
    englishTranslation: "French",
    pronunciation: "fran-see",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "fransia (f.)",
    englishTranslation: "French",
    pronunciation: "fran-see-ya",
    exampleSentence: "ana fransi",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "allemagne",
    englishTranslation: "Germany",
    pronunciation: "al-man",
    exampleSentence: "ana min allemagne",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "almani (m.)",
    englishTranslation: "German",
    pronunciation: "al-ma-nee",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "almania (f.)",
    englishTranslation: "German",
    pronunciation: "al-ma-nee",
    exampleSentence: "ana almania",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "la holland",
    englishTranslation: "Holland",
    pronunciation: "la ho-lond",
    exampleSentence: "ana min la holland",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "hollandi (m.)",
    englishTranslation: "Dutch",
    pronunciation: "hol-on-dee",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "hollandia (f.)",
    englishTranslation: "Dutch",
    pronunciation: "hol-on-dee-ya",
    exampleSentence: "ana hollandi",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "la chin",
    englishTranslation: "China",
    pronunciation: "la -shin",
    exampleSentence: "ana min la chin",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "chinwi (m.)",
    englishTranslation: "Chinese",
    pronunciation: "shin-wee",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "chinwia (f.)",
    englishTranslation: "Chinese",
    pronunciation: "shin-wee-ya",
    exampleSentence: "ana chinwia",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "amrika",
    englishTranslation: "America",
    pronunciation: "am-ree-ka",
    exampleSentence: "ana min amrika",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "amriki (m.)",
    englishTranslation: "American",
    pronunciation: "am-ree-kee",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "amrikia (f.)",
    englishTranslation: "American",
    pronunciation: "am-ree-kee-ya",
    exampleSentence: "ana amriki",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "romania",
    englishTranslation: "Romania",
    pronunciation: "ro-man-ya",
    exampleSentence: "ana min romania",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "romani (m.)",
    englishTranslation: "Romanian",
    pronunciation: "ro-ma-ni",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "romania (f.)",
    englishTranslation: "Romanian",
    pronunciation: "ro-man-ya",
    exampleSentence: "ana romania",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "espanya",
    englishTranslation: "Spain",
    pronunciation: "es-pan-ya",
    exampleSentence: "ana min espanya",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "spanyoli (m.)",
    englishTranslation: "Spanish",
    pronunciation: "span-yo-li",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "spanyolia (f.)",
    englishTranslation: "Spanish",
    pronunciation: "span-yo-lee-ya",
    exampleSentence: "ana spanyoli",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "turk",
    englishTranslation: "Turkey",
    pronunciation: "turk",
    exampleSentence: "ana min turk",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "turki (m.)",
    englishTranslation: "Turkish",
    pronunciation: "tur-kee",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "turkia (f.)",
    englishTranslation: "Turkish",
    pronunciation: "tur-kee-ya",
    exampleSentence: "ana turkia",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "maroc",
    englishTranslation: "Morocco",
    pronunciation: "ma-rok",
    exampleSentence: "ana min maroc",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "marocci (m.)",
    englishTranslation: "Moroccan",
    pronunciation: "ma-rok-ki",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "maroccia (f.)",
    englishTranslation: "Moroccan",
    pronunciation: "ma-rok-ki-ya",
    exampleSentence: "ana marocci",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "falestin",
    englishTranslation: "Palestine",
    pronunciation: "fa-les-Teen",
    exampleSentence: "ana min falestin",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "falestini (m.)",
    englishTranslation: "Palestinian",
    pronunciation: "fa-les-Tee-ni",
    exampleSentence: "",
    category: "countries",
    difficulty: "beginner"
  },
  {
    algerianWord: "falestinia (f.)",
    englishTranslation: "Palestinian",
    pronunciation: "fa-les-Tee-ni-ya",
    exampleSentence: "ana falestinia",
    category: "countries",
    difficulty: "beginner"
  },

  // NUMBERS - Your authentic list
  {
    algerianWord: "sifr",
    englishTranslation: "0",
    pronunciation: "si-fer",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "wa7ed",
    englishTranslation: "1",
    pronunciation: "we-Hed",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "zouj",
    englishTranslation: "2",
    pronunciation: "z-ouj",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "tleta",
    englishTranslation: "3",
    pronunciation: "t-le-ta",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "reb3a",
    englishTranslation: "4",
    pronunciation: "re-ba'a-a",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "khamsa",
    englishTranslation: "5",
    pronunciation: "kham-sa",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "seta",
    englishTranslation: "6",
    pronunciation: "se-ta",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "seb3a",
    englishTranslation: "7",
    pronunciation: "se-ba'a-a",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "tmenya",
    englishTranslation: "8",
    pronunciation: "tem-en-ya",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "tes3a",
    englishTranslation: "9",
    pronunciation: "te-sa'a-a",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "3shra",
    englishTranslation: "10",
    pronunciation: "a'ash-ra",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "7edesh",
    englishTranslation: "11",
    pronunciation: "ħed-esh",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "tenash",
    englishTranslation: "12",
    pronunciation: "ten-ash",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "teltash",
    englishTranslation: "13",
    pronunciation: "tel-Tash",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "reb3tash",
    englishTranslation: "14",
    pronunciation: "re-ba'a-Tash",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "khamstash",
    englishTranslation: "15",
    pronunciation: "khams-Tash",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "setash",
    englishTranslation: "16",
    pronunciation: "se-Tash",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "seb3tash",
    englishTranslation: "17",
    pronunciation: "se-ba'a-Tash",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "tmentash",
    englishTranslation: "18",
    pronunciation: "tem-en-Tash",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "tes3tash",
    englishTranslation: "19",
    pronunciation: "te-sa'a-Tash",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "3shrin",
    englishTranslation: "20",
    pronunciation: "a'ash-reen",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "tletin",
    englishTranslation: "30",
    pronunciation: "tle-teen",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "reb3in",
    englishTranslation: "40",
    pronunciation: "reb-a'aeen",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "khamsin",
    englishTranslation: "50",
    pronunciation: "kham-seen",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "setin",
    englishTranslation: "60",
    pronunciation: "set-een",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "seb3in",
    englishTranslation: "70",
    pronunciation: "se-ba'a-een",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "tmenin",
    englishTranslation: "80",
    pronunciation: "tme-neen",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  { 
    algerianWord: "temenyin",
    englishTranslation: "80",
    pronunciation: "tem-en-yin",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "tes3in",
    englishTranslation: "90",
    pronunciation: "te-sa'a-een",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },
  {
    algerianWord: "miya",
    englishTranslation: "100",
    pronunciation: "mee-ya",
    exampleSentence: "",
    category: "numbers",
    difficulty: "beginner"
  },

  // FAMILY - Your authentic vocabulary
  {
    algerianWord: "oum",
    englishTranslation: "mother",
    pronunciation: "um",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "yima",
    englishTranslation: "mother",
    pronunciation: "yima",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "mama",
    englishTranslation: "mother",
    pronunciation: "mama",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "ab",
    englishTranslation: "father",
    pronunciation: "eb",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "baba",
    englishTranslation: "father",
    pronunciation: "baba",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "beba",
    englishTranslation: "father",
    pronunciation: "beba",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "papa",
    englishTranslation: "father",
    pronunciation: "papa",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "oukht",
    englishTranslation: "sister",
    pronunciation: "ukht",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "kho",
    englishTranslation: "brother",
    pronunciation: "kho",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "rajel",
    englishTranslation: "husband",
    pronunciation: "ra-jul",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "mra",
    englishTranslation: "wife",
    pronunciation: "m-ra",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "bent",
    englishTranslation: "daughter",
    pronunciation: "bint",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "wlid",
    englishTranslation: "son",
    pronunciation: "w-leed",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "jed",
    englishTranslation: "grandfather",
    pronunciation: "jed",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "jeda",
    englishTranslation: "grandmother",
    pronunciation: "jeda",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "3em",
    englishTranslation: "paternal uncle",
    pronunciation: "a'a-em",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "3ema",
    englishTranslation: "paternal auntie",
    pronunciation: "a'a-ema",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "khal",
    englishTranslation: "maternal uncle",
    pronunciation: "khal",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },
  {
    algerianWord: "khala",
    englishTranslation: "maternal auntie",
    pronunciation: "kha-la",
    exampleSentence: "",
    category: "family",
    difficulty: "beginner"
  },

  // FOOD - Your authentic vocabulary
  {
    algerianWord: "7lib",
    englishTranslation: "milk",
    pronunciation: "Ha-leeb",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "atay",
    englishTranslation: "tea",
    pronunciation: "e-tey",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "9ahwa",
    englishTranslation: "coffee",
    pronunciation: "qah-wa",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "jus",
    englishTranslation: "juice",
    pronunciation: "joo",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "gazeuses",
    englishTranslation: "fizzy / soda",
    pronunciation: "ge-zooz",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "lma",
    englishTranslation: "water",
    pronunciation: "el-ma",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "fekya",
    englishTranslation: "fruit",
    pronunciation: "fek-ya",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "tchina",
    englishTranslation: "orange",
    pronunciation: "chee-na",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "tufe7",
    englishTranslation: "apple",
    pronunciation: "tuf-eħ",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "banane",
    englishTranslation: "banana",
    pronunciation: "be-nen",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "l3neb",
    englishTranslation: "grapes",
    pronunciation: "la'a-neb",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "dela3",
    englishTranslation: "watermelon",
    pronunciation: "del-ea'a",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "batikh",
    englishTranslation: "melon",
    pronunciation: "ba-tikh",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "frais",
    englishTranslation: "strawberries",
    pronunciation: "frez",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "9ares",
    englishTranslation: "lemon",
    pronunciation: "qa-res",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "khokh",
    englishTranslation: "peach",
    pronunciation: "kho-kh",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "tout",
    englishTranslation: "raspberries",
    pronunciation: "toot",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "ananas",
    englishTranslation: "pineapple",
    pronunciation: "a-na-nas",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "khudr",
    englishTranslation: "vegetables",
    pronunciation: "khu-der",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "9er3a",
    englishTranslation: "courgette",
    pronunciation: "qa-ra'a-a",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "bsel",
    englishTranslation: "onion",
    pronunciation: "b--sel",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "toum",
    englishTranslation: "garlic",
    pronunciation: "toom",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "felfel",
    englishTranslation: "pepper",
    pronunciation: "fil-fil",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "felfel 7ar",
    englishTranslation: "chilli",
    pronunciation: "fil-fil Har",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "loubia machtou",
    englishTranslation: "green beans",
    pronunciation: "loo-bee-ya mash-to",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "jelbana",
    englishTranslation: "peas",
    pronunciation: "jil-be-na",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "9arnoun",
    englishTranslation: "artichoke",
    pronunciation: "qar-noon",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "7misa",
    englishTranslation: "chickpeas",
    pronunciation: "Hem-ee-sa",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "zitoun",
    englishTranslation: "olives",
    pronunciation: "zee-toon",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "maïs",
    englishTranslation: "sweeetcorn",
    pronunciation: "ma-yeez",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "left",
    englishTranslation: "turnip",
    pronunciation: "left",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "bedenjel",
    englishTranslation: "aubergine",
    pronunciation: "be-den-jel",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "l7em",
    englishTranslation: "meat",
    pronunciation: "el-Hem",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "les côtlettes",
    englishTranslation: "lamb chops",
    pronunciation: "li cot-let",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "viande hachée",
    englishTranslation: "minced meat",
    pronunciation: "vi-ond ash-ee",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "l7em mer7i",
    englishTranslation: "minced meat",
    pronunciation: "el-Hem mer-Hee",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "jej",
    englishTranslation: "chicken",
    pronunciation: "jej",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "7out",
    englishTranslation: "fish",
    pronunciation: "Hoot",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "serdine",
    englishTranslation: "sardines",
    pronunciation: "ser-deen",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "crevettes",
    englishTranslation: "prawns",
    pronunciation: "crev-et",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "le mul",
    englishTranslation: "mussels",
    pronunciation: "ley mool",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "saumon",
    englishTranslation: "salmon",
    pronunciation: "su-mo",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "lbid",
    englishTranslation: "eggs",
    pronunciation: "el-biD",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "fromage",
    englishTranslation: "cheese",
    pronunciation: "fro-maj",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "ma9aron",
    englishTranslation: "pasta",
    pronunciation: "ma-qa-ron",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "roz",
    englishTranslation: "rice",
    pronunciation: "roz",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "khoubz",
    englishTranslation: "bread",
    pronunciation: "khubz",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "sandwich",
    englishTranslation: "sandwich",
    pronunciation: "sond-wich",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "chicoula",
    englishTranslation: "chocolate",
    pronunciation: "shi-coo-la",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "7elwa",
    englishTranslation: "sweets",
    pronunciation: "ħel-wa",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },
  {
    algerianWord: "gâteau",
    englishTranslation: "cake / biscuit",
    pronunciation: "ga-tu",
    exampleSentence: "",
    category: "food",
    difficulty: "beginner"
  },

  // EVERYDAY PHRASES - Your authentic vocabulary
  {
    algerianWord: "nsta9ahwa",
    englishTranslation: "I have breakfast / drink coffee",
    pronunciation: "nes-ta-qah-wa",
    exampleSentence: "nsta9ahwa kol youm = I have breakfast every day",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "nefter",
    englishTranslation: "I have lunch",
    pronunciation: "nef-Ter",
    exampleSentence: "nefter 3a tenash - I have lunch at 12",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "net3sha",
    englishTranslation: "I have dinner",
    pronunciation: "ne-ta'a-sha",
    exampleSentence: "net3sha m3a mama = I have dinner with my mum",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "rani nsta9ahwa",
    englishTranslation: "I am having breakfast / drinking coffee",
    pronunciation: "ra-ni nes-ta-qah-wa",
    exampleSentence: "",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "lezem nshri",
    englishTranslation: "I need to go shopping / I need to buy [something]",
    pronunciation: "le-zem en-shree",
    exampleSentence: "lezem nshri 7lib = I need to buy milk",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "rani ner9oud",
    englishTranslation: "I am sleeping",
    pronunciation: "ra-nee ner-qud",
    exampleSentence: "eskout! rani ner9oud! = be quiet! I'm sleeping!",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "r9edt",
    englishTranslation: "I slept",
    pronunciation: "re-qedt",
    exampleSentence: "r9edt bekri lbere7 = I slept early yesterday",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "rani nod",
    englishTranslation: "I am waking up",
    pronunciation: "ra-nee en-nod",
    exampleSentence: "",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "nodt",
    englishTranslation: "I woke up",
    pronunciation: "nodt",
    exampleSentence: "",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "rani nayed (m.)",
    englishTranslation: "I am awake",
    pronunciation: "ra-nee na-yid",
    exampleSentence: "",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "rani nayda (f.)",
    englishTranslation: "I am awake",
    pronunciation: "ra-nee nay-da",
    exampleSentence: "",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "rani nelbes",
    englishTranslation: "I am wearing ... / I am getting dressed",
    pronunciation: "ra-nee nel-bes",
    exampleSentence: "",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "rani nghsel",
    englishTranslation: "I am washing ...",
    pronunciation: "ra-nee negh-sil",
    exampleSentence: "rani nghsel yediya = I am washing my hands",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "ghselt",
    englishTranslation: "I washed ...",
    pronunciation: "ghe-selt",
    exampleSentence: "ghselt l7awayij = I washed the clothes",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "rani ne9ra",
    englishTranslation: "I am studying / reading",
    pronunciation: "ra-nee neq-ra",
    exampleSentence: "rani ne9ra langlais = I am studying English",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "9rit",
    englishTranslation: "I studied / read ...",
    pronunciation: "qer-eet",
    exampleSentence: "9rit langlais = I studied English",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "rani nel3ab",
    englishTranslation: "I am playing",
    pronunciation: "ra-nee ne-la'a-ab",
    exampleSentence: "rani nel3ab m3a benti = I am playing with my daughter",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "l3abt",
    englishTranslation: "I played",
    pronunciation: "la'a-abt",
    exampleSentence: "l3abt ballon = I played football",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "rani ne9i",
    englishTranslation: "I am cleaning",
    pronunciation: "ra-nee ne-9ee",
    exampleSentence: "rani ne9i f salon = I am cleaning the living room",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "ne9it",
    englishTranslation: "I cleaned",
    pronunciation: "ne-qeet",
    exampleSentence: "ne9it tonobil = I cleaned the car",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "rani nemse7",
    englishTranslation: "I am wiping down [...]",
    pronunciation: "ra-nee nem-seħ",
    exampleSentence: "rani nemse7 f couzina = I am wiping down the kitchen",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "mse7t",
    englishTranslation: "I wiped down [...]",
    pronunciation: "em-seHt",
    exampleSentence: "mse7t salle de bain = I wiped down the bathroom",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "n7eb",
    englishTranslation: "I like / love ...",
    pronunciation: "en-Heb",
    exampleSentence: "",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "7ebit",
    englishTranslation: "I liked / loved ... / I want ... / wanted ...",
    pronunciation: "Heb-eet",
    exampleSentence: "7ebit crevettes ki kunt sghira = I liked prawns when I was young",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "nekra",
    englishTranslation: "I hate ...",
    pronunciation: "ne-kra",
    exampleSentence: "",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "ne9der",
    englishTranslation: "I can",
    pronunciation: "neq-der",
    exampleSentence: "ne9der nro7 m3ah = I can go with him",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "nel9a",
    englishTranslation: "I find",
    pronunciation: "nel-qa",
    exampleSentence: "rani nsiyi nel9a tilifuni = I'm trying to find my phone",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "l9it",
    englishTranslation: "I found",
    pronunciation: "el-qeet",
    exampleSentence: "l9it tilifuni = I found my phone",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "nkhdem",
    englishTranslation: "I work",
    pronunciation: "nekh-dem",
    exampleSentence: "nkhdem ghedwa = I work tomorrow",
    category: "phrases",
    difficulty: "intermediate"
  },
  {
    algerianWord: "khdemt",
    englishTranslation: "I worked",
    pronunciation: "kh-demt",
    exampleSentence: "khdemt lbere7 = I worked yesterday",
    category: "phrases",
    difficulty: "intermediate"
  }
];

// Import function to bulk add vocabulary
export const importVocabulary = async () => {
  const results = [];
  let successCount = 0;
  let errorCount = 0;

  for (const word of algerianVocabulary) {
    try {
      await vocabularyAPI.create(word);
      results.push({ word: word.algerianWord, status: 'success' });
      successCount++;
    } catch (error) {
      results.push({ word: word.algerianWord, status: 'error', error: error.message });
      errorCount++;
    }
  }

  return {
    total: algerianVocabulary.length,
    success: successCount,
    errors: errorCount,
    results
  };
};